import type { PanelType, Res, TechTrack } from '@/types'

import base from './base'

export const panelApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getPanelContent: builder.query<PanelType[], void>({
      query: () => 'teachers/panels',
      transformResponse: (res: Res<PanelType[]>) => res.data,
    }),

    getTechTracks: builder.query<TechTrack[], void>({
      query: () => 'teachers/tech-tracks',
      transformResponse: (res: Res<TechTrack[]>) => res.data,
      providesTags: ['TechTracks'],
    }),
  }),
})

export const { useGetPanelContentQuery, useGetTechTracksQuery } = panelApi
